export default "__VITE_ASSET__fWagAZdC__"